"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollapsiblePaper;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireWildcard(require("react"));
var _TitledPaper = require("../TitledPaper");
var _ArrowUpwardIcon, _ArrowDownwardIcon;
var _excluded = ["children"],
  _excluded2 = ["children", "className", "hasDivider", "hasMoveDeleteButtons", "headerComponent", "hideCollapse", "hideMoveButtons", "hideDeleteButton", "id", "isActive", "onDelete", "onMove", "wideChildren", "canDelete", "canMoveDown", "canMoveUp"];
/* eslint-disable react/no-array-index-key */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    buttonlessBody: {
      paddingRight: theme.spacing(3)
    },
    divider: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(0)
    },
    headerBox: {
      paddingRight: '0px !important'
    },
    hidden: {
      visibility: 'hidden'
    }
  };
});
var CollapseGridItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, (0, _extends2.default)({
    ref: ref,
    item: true
  }, props, {
    xs: 12
  }), children);
});
function CollapsiblePaper(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    hasDivider = _ref2.hasDivider,
    _ref2$hasMoveDeleteBu = _ref2.hasMoveDeleteButtons,
    hasMoveDeleteButtons = _ref2$hasMoveDeleteBu === void 0 ? true : _ref2$hasMoveDeleteBu,
    headerComponent = _ref2.headerComponent,
    hideCollapse = _ref2.hideCollapse,
    _ref2$hideMoveButtons = _ref2.hideMoveButtons,
    hideMoveButtons = _ref2$hideMoveButtons === void 0 ? false : _ref2$hideMoveButtons,
    _ref2$hideDeleteButto = _ref2.hideDeleteButton,
    hideDeleteButton = _ref2$hideDeleteButto === void 0 ? false : _ref2$hideDeleteButto,
    id = _ref2.id,
    isActive = _ref2.isActive,
    onDelete = _ref2.onDelete,
    onMove = _ref2.onMove,
    wideChildren = _ref2.wideChildren,
    _ref2$canDelete = _ref2.canDelete,
    canDelete = _ref2$canDelete === void 0 ? onDelete && hasMoveDeleteButtons || false : _ref2$canDelete,
    _ref2$canMoveDown = _ref2.canMoveDown,
    canMoveDown = _ref2$canMoveDown === void 0 ? onMove && hasMoveDeleteButtons || false : _ref2$canMoveDown,
    _ref2$canMoveUp = _ref2.canMoveUp,
    canMoveUp = _ref2$canMoveUp === void 0 ? onMove && hasMoveDeleteButtons || false : _ref2$canMoveUp,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var classes = useStyles();
  var collapseTimeoutMillis = 100;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var GridItem = _react.default.useMemo(function () {
    return CollapseGridItem;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TitledPaper.StyledPaper, (0, _extends2.default)({
    key: "".concat(id, "Paper"),
    className: className || '',
    id: id,
    square: true
  }, props), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, hasDivider && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, {
    className: classes.divider
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    align: "center",
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "Collapse",
    className: hideCollapse ? classes.hidden : '',
    id: "".concat(id, "CollapseButton"),
    onClick: function onClick() {
      setCollapsed(!collapsed);
    },
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandLess, {
    style: {
      transform: collapsed ? 'rotate(-180deg)' : '',
      transition: "transform ".concat(collapseTimeoutMillis, "ms linear")
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: hasMoveDeleteButtons ? '' : classes.buttonlessBody,
    container: true,
    spacing: 2
  }, headerComponent && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.headerBox,
    component: _material.Grid,
    container: true,
    item: true,
    minHeight: 64,
    spacing: 2,
    xs: 12
  }, headerComponent), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    component: CollapseGridItem,
    in: !collapsed,
    timeout: collapseTimeoutMillis,
    unmountOnExit: true
  }, children))), hasMoveDeleteButtons && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    md: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: hideMoveButtons || !isActive ? classes.hidden : '',
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    title: "Move up"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    disabled: !canMoveUp,
    id: "".concat(id, "MoveUpButton"),
    onClick: function onClick() {
      if (onMove) onMove(-1, id);
    },
    size: "small"
  }, _ArrowUpwardIcon || (_ArrowUpwardIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ArrowUpward, null)))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: hideMoveButtons || !isActive ? classes.hidden : '',
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    title: "Move down"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    disabled: !canMoveDown,
    id: "".concat(id, "MoveDownButton"),
    onClick: function onClick() {
      if (onMove) onMove(1, id);
    },
    size: "small"
  }, _ArrowDownwardIcon || (_ArrowDownwardIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ArrowDownward, null)))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: hideDeleteButton || !isActive ? classes.hidden : '',
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    title: "Delete"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "Delete",
    disabled: !canDelete,
    id: "".concat(id, "DeleteButton"),
    onClick: function onClick() {
      if (onDelete) onDelete(id);
    },
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Delete, {
    color: canDelete ? 'error' : 'disabled'
  }))))))))), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    component: GridItem,
    in: !collapsed,
    timeout: collapseTimeoutMillis,
    unmountOnExit: true
  }, wideChildren));
}